import { Col, Container, Row, Section } from 'hui';
import React from 'react';
import styled from 'styled-components';
import { HeaderContextProvider } from './HeaderContext';
import { logo } from './presentational/left';
import HeaderActions from './presentational/right/header-actions';

export const Logo = styled.a`
  display: block;
  height: 30px;
  width: 80px;
  flex: 0 0 80px;
  background: url(${logo}) no-repeat;
  background-size: contain;
`;

// eslint-disable-next-line ban/ban
const RightCol = styled(Col)`
  text-align: right;
  justify-self: flex-end;
  flex: 1;
  display: flex;
  justify-content: flex-end;
`;
// eslint-disable-next-line ban/ban
const FixedRightRow = styled(Row)`
  height: 70px;
  align-items: center;
`;

const HeaderSimple: React.FC = () => {
  const siteSource = 'Header Simple';
  return (
    <HeaderContextProvider
      hasSearch={false}
      siteSource={'HeaderSimple'}
      loginData={{ logged_in: false }}
      breakPoint={'1rem'}
    >
      <Section color={'tint6'}>
        <Container>
          <FixedRightRow>
            <Logo
              href="/"
              data-ga-category={siteSource}
              data-ga-action={`${siteSource} - Clicked Home`}
              data-ga-label={`${siteSource} - Clicked Home`}
            />
            <RightCol>
              <HeaderActions />
            </RightCol>
          </FixedRightRow>
        </Container>
      </Section>
    </HeaderContextProvider>
  );
};

export default HeaderSimple;
